import { useQuery } from "@tanstack/react-query";

import { fetchSchedulingParticipants } from "src/services/adminSchedulingService";

export const SCHEDULING_PARTICIPANTS_QUERY_KEY = ["admin", "scheduling-participants"] as const;

export const useSchedulingParticipants = () => {
  return useQuery({
    queryKey: SCHEDULING_PARTICIPANTS_QUERY_KEY,
    queryFn: fetchSchedulingParticipants,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
